import React from "react"
import badge from "badges/resource-management.svg"
import { BadgeImage } from "backpack/badges/styled"

const ResourceManagement = props => <BadgeImage src={badge} {...props} />

export default ResourceManagement
